import BreakfastData from './BreakfastData';
import './BreakfastStyles.css';


export default function Breakfast(){
    return (
        <div class="breakfast">
            <h1>Breakfast Recipes</h1>
            <BreakfastData className ="first-rec"
            heading ="1 to 20"
            text="Omelette"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1646579933415-92109f9805df?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mjd8fG9tZWxldHRlfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/sAa-CEl5Z-k?si=Q5wjDxJXAP0KDQh4"
            />
            <BreakfastData className ="first-rec"
            heading ="2 to 20"
            text="Three-Ingredient Pancakes"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1593999486471-e3d4dd99e81b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGJhbmFuYSUyMHBhbmNha2VzfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/_VR8BYxLhbQ?si=UvA7_PC5FVNenExR"
            />
            <BreakfastData className ="first-rec"
            heading ="3 to 20"
            text="Fruit & Yogurt Smoothie"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1553177595-4de2bb0842b9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8ZnJ1aXQlMjBhbmQlMjB5b2d1cnQlMjBzbW9vdGhpZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/94AV_epDjb4?si=6rGl-cch99_1Lt4p"
            />
            <BreakfastData className ="first-rec"
            heading ="4 to 20"
            text="Upma"
            btnText=" Recipe"
            img="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRS2Cjox7mmHBaLaFEGL0Flt49zRrr25Ql5SA&usqp=CAU"
            url ="https://youtu.be/zpMqTRadZXM?si=DZ4m_F5agpd_bYpl"
            />
            <BreakfastData className ="first-rec"
            heading ="5 to 20"
            text="Pooha"
            btnText=" Recipe"
            img="https://i.pinimg.com/236x/d2/a0/59/d2a0598b46e40016cef97c2bf566d6a7.jpg"
            url="https://youtu.be/a3dq7eADEug?si=-xmnfsq65KSrtiZh"
            />
            <BreakfastData className ="first-rec"
            heading ="6 to 20"
            text="Besan Chilla"
            btnText=" Recipe"
            img="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzeTjcAQa7z5fS_svGzn68s6bFMpIZ1talzw&usqp=CAU"
            url="https://youtu.be/QROJTp9011s?si=8aWkhwOx1VBum68r"
            />
            <BreakfastData className ="first-rec"
            heading ="7 to 20"
            text="Egg Sandwich"
            btnText=" Recipe"
            img="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8pVT6pl1BMaFNZTty1ttTQeuHJWG0aEtsOA&usqp=CAU"
            url="https://youtu.be/oDK4IHIMGsw?si=vj0VaoTfCS6fblLL"
            />
            <BreakfastData className ="first-rec"
            heading ="8 to 20"
            text="Oatmeal Bowl"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1583687463124-ff2aa00b1160?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fG9hdHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/VZOHHCosuzY?si=N3AN1utcXDAPn0GN"
            />
            <BreakfastData className ="first-rec"
            heading ="9 to 20"
            text="Milk Shakes"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1505576540771-be91e4753e0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fE1pbGslMjBzaGFrZXN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/uT-cp7CJIW0?si=mIQDH2ei4TLlsrTz"
            />
            <BreakfastData className ="first-rec"
            heading ="10 to 20"
            text="Veg Sandwich"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1619096252214-ef06c45683e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fHNhbmR3aWNofGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/BlzJzavriHw?si=P4SgWhXZS3A1Jk37"
            />
            <BreakfastData className ="first-rec"
            heading ="11 to 20"
            text="Wheat Flour Dosa"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1630409351241-e90e7f5e434d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8aW5kaWFuJTIwZG9zYXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/JD9mHQjuaNI?si=Ang2ZifpTT_omdZn"
            />
            <BreakfastData className ="first-rec"
            heading ="12 to 20"
            text="Salad Bowl"
            btnText=" Recipe"
            img="https://plus.unsplash.com/premium_photo-1664648005706-98c10e27949f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzF8fHNhbGFkJTIwYm93bHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/nzNQ5lTmg1Q?si=37e_nMWEPJureHIP"
            />
            <BreakfastData className ="first-rec"
            heading ="13 to 20"
            text="French Toast"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1484723091739-30a097e8f929?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZnJlbmNoJTIwdG9hc3R8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/EARnchvnbVI?si=6Rt0XOO6lgWtUQt_"
            />
            <BreakfastData className ="first-rec"
            heading ="14 to 20"
            text="Vegetable and Quinoa"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1594782855419-e646186ad78f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjZ8fHF1aW5vYXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/QJkEs9B34X8?si=fFGrraHb_p5HeSc1"
            />
            <BreakfastData className ="first-rec"
            heading ="15 to 20"
            text="Warm Soup Bowl"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1603105037880-880cd4edfb0d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8c291cCUyMGJvd2x8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/JjoaBoTWCUM?si=w2CRO5goBqmxUj7S"
            />
            <BreakfastData className ="first-rec"
            heading ="16 to 20"
            text="Chia Pudding"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1552528352-59648b345866?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y2hpYSUyMHB1ZGRpbmd8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/zJQKxzZpDJw?si=kUlln3UpiPF2Uvyy"
            />
            <BreakfastData className ="first-rec"
            heading ="17 to 20"
            text="Egg Burji(Indian Spiced Scrambled eggs)"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1524250981170-bd522ef63fbf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c2NyYW1ibGVkJTIwZWdnc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/EMTCplPvF0Y?si=d91t6U8eWeHo2VUe"
            />
            <BreakfastData className ="first-rec"
            heading ="18 to 20"
            text="Dalia Porridge"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1515544645059-de313dd20a58?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cG9ycmlkZ2V8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/x63RvKofXUA?si=SiT5lZ9UWaTdgCtk"
            />
            <BreakfastData className ="first-rec"
            heading ="19 to 20"
            text="Fruit Chaat"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1549248287-f371a6246ea6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NzR8fGZydWl0JTIwc2FsYWR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/J_K1x-UIcJ8?si=deSbqKkrHWfSZ0SQ"
            />
            <BreakfastData className ="first-rec"
            heading ="20 to 20"
            text="Masala Dalia"
            btnText=" Recipe"
            img="https://images.unsplash.com/photo-1547120013-84d805b0d3c2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fG1hc2FsYSUyMHBvcnJpZGdlfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60"
            url="https://youtu.be/23nU5Meev34?si=Z2xnRwwSLcVzT1Fd"
            />

        </div>
    )
}